import React, { Fragment } from 'react';
import ReactDOM from 'react-dom';
import { saiki, api, tanggalIndo, rendModal, numberFormat, rendTable, getCookie, submitForm, pesan } from "../modul";
import DataGrid, { Column, Paging, FilterRow, HeaderFilter, Grouping, GroupPanel, ColumnFixing, Summary, TotalItem, GroupItem, Pager } from 'devextreme-react/data-grid';
import 'devextreme/dist/css/dx.light.css';
import 'devextreme/dist/css/dx.material.blue.light.compact.css'

function App() {
    document.title = "Penagihan Selesai";
    class Main extends React.Component {
        constructor(props) {
            super(props);
            this.state = {
                search: '',
                searchcount: 50,
                index: 0,
                sort: "DocDate",
                by: "DESC",
                SalesID: "",
                Field: [
                    { cap: "", sort: "", type: "opsi", width: "80px" },
                    { cap: "Tanggal", sort: "DocDate", width: "120px" },
                    { cap: "Nomor Dokumen", sort: "DocNumber", width: "180px" },
                    { cap: "Pelanggan", sort: "Customer", width: "280px", type: "html" },
                    { cap: "Sales", sort: "SalesName", width: "120px" },
                    { cap: "Total Invoice", sort: "Total", type: "str" },
                ],
                D1: window.sessionStorage.getItem("D1SelesaiKasir") || saiki("1"),
                D2: window.sessionStorage.getItem("D2SelesaiKasir") || saiki()
            };
        }

        async componentDidMount() {
            ReactDOM.render("", document.getElementById('divHeaderLabel'));
            this.main();
        }

        handleChange(e, ssts) {
            this.setState({ [ssts]: e.target.value });
            this.main();
        }

        handleChangeDate(dd, val) {
            window.sessionStorage.setItem(dd, val);
            if (dd == "D1SelesaiKasir") {
                this.setState({ "D1": val });
            } else {
                this.setState({ "D2": val });
            }
        }

        handlePage(e) {
            e.preventDefault();
            this.setState({ index: e.target.dataset.val });
            setTimeout(() => {
                this.main();
            }, 100);
        }

        handleSort(e) {
            if (this.state.sort == e.target.dataset.sort) {
                if (this.state.by === "ASC") {
                    this.setState({ by: "DESC" });
                } else {
                    this.setState({ by: "ASC" });
                }
            } else {
                this.setState({ sort: e.target.dataset.sort });
            }
            setTimeout(() => { this.main(); }, 100);
        }

        async main() {
            let param = {
                search: this.state.search,
                index: this.state.index,
                searchcount: this.state.searchcount,
                KasirID: getCookie("UserID"),
                sort: this.state.sort,
                by: this.state.by,
                state: "4",
                SalesID: this.state.SalesID,
                D1: this.state.D1,
                D2: this.state.D2,
                Token: getCookie("Token")
            }
            let sql = await api("list_tagihan_selesai_kasir", param);
            if (sql.status == "true") this.setState({ data: sql.data });
        }

        async handlePrint() {
            let param = {
                D1: this.state.D1,
                D2: this.state.D2,
                Token: getCookie("Token")
            }
            let sql = await api("list_detail_tagihan_selesai_kasir", param);
            let dom = [];
            if (sql.status == "true") {
                for (let tgl of sql.docdate) {
                    let TotalSales = 0, TotalType = 0;
                    dom.push(<Fragment>
                        <h3 style={{ textAlign: "center" }}>{tanggalIndo(tgl.DocDate)}</h3>
                        {
                            sql.sales.map((sales, salesi) => {
                                let ctTF = [], domTF = [], ctTunai = [], domTunai = [], ctGiro = [], domGiro = [], ctAll = 0;
                                for (let data of sql.data) if (data.SalesID == sales.SalesID && data.DocDate == tgl.DocDate) ctAll++;
                                if (ctAll > 0) {
                                    for (let data of sql.data) if (data.SalesID == sales.SalesID && data.PaymentType == "Transfer" && data.DocDate == tgl.DocDate) ctTF.push(data);
                                    for (let data of sql.data) if (data.SalesID == sales.SalesID && data.PaymentType == "Tunai" && data.DocDate == tgl.DocDate) ctTunai.push(data);
                                    for (let data of sql.data) if (data.SalesID == sales.SalesID && data.PaymentType == "Giro" && data.DocDate == tgl.DocDate) ctGiro.push(data);
                                    if (ctTF.length > 0) {
                                        domTF = (
                                            <Fragment>
                                                <h6>Transfer</h6>
                                                <div className='table-responsive'>
                                                    <table className='table table-bordered'>
                                                        <thead>
                                                            <tr>
                                                                <th>No Invoice</th>
                                                                <th>Nama Customer</th>
                                                                <th>Saldo Awal</th>
                                                                <th>Amount</th>
                                                                <th>Saldo Akhir</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {ctTF.map((item, index) => {
                                                                if (item.DocDate == tgl.DocDate) {
                                                                    return (
                                                                        <tr key="index">
                                                                            <td>{item.NoInvoice}</td>
                                                                            <td>{item.CustomerName}</td>
                                                                            <td>{numberFormat(item.AmountOpen)}</td>
                                                                            <td>{numberFormat(item.Amount)}</td>
                                                                            <td>{numberFormat(item.AmountBalance)}</td>
                                                                        </tr>
                                                                    )
                                                                }
                                                            })}
                                                        </tbody>
                                                        <tfoot>
                                                            <tr>
                                                                <td colSpan='2' style={{ textAlign: "right" }}>Total</td>
                                                                <td>{numberFormat(ctTF.reduce((a, b) => a + b.AmountOpen, 0))}</td>
                                                                <td>{numberFormat(ctTF.reduce((a, b) => a + b.Amount, 0))}</td>
                                                                <td>{numberFormat(ctTF.reduce((a, b) => a + b.AmountBalance, 0))}</td>
                                                            </tr>
                                                        </tfoot>
                                                    </table>
                                                </div>
                                            </Fragment>
                                        )
                                    }

                                    if (ctTunai.length > 0) {
                                        domTunai = (
                                            <Fragment>
                                                <h6>Tunai</h6>
                                                <div className='table-responsive'>
                                                    <table className='table table-bordered'>
                                                        <thead>
                                                            <tr>
                                                                <th>No Invoice</th>
                                                                <th>Nama Customer</th>
                                                                <th>Saldo Awal</th>
                                                                <th>Amount</th>
                                                                <th>Saldo Akhir</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {ctTunai.map((item, index) => {
                                                                if (item.DocDate == tgl.DocDate) {
                                                                    return (
                                                                        <tr key={index}>
                                                                            <td>{item.NoInvoice}</td>
                                                                            <td>{item.CustomerName}</td>
                                                                            <td>{numberFormat(item.AmountOpen)}</td>
                                                                            <td>{numberFormat(item.Amount)}</td>
                                                                            <td>{numberFormat(item.AmountBalance)}</td>
                                                                        </tr>
                                                                    )
                                                                }
                                                            })}
                                                        </tbody>
                                                        <tfoot>
                                                            <tr>
                                                                <td colSpan='2' style={{ textAlign: "right" }}>Total</td>
                                                                <td>{numberFormat(ctTunai.reduce((a, b) => a + b.AmountOpen, 0))}</td>
                                                                <td>{numberFormat(ctTunai.reduce((a, b) => a + b.Amount, 0))}</td>
                                                                <td>{numberFormat(ctTunai.reduce((a, b) => a + b.AmountBalance, 0))}</td>
                                                            </tr>
                                                        </tfoot>
                                                    </table>
                                                </div>
                                            </Fragment>
                                        )
                                    }

                                    if (ctGiro.length > 0) {
                                        domGiro = (
                                            <Fragment>
                                                <h6>Giro</h6>
                                                <div className='table-responsive'>
                                                    <table className='table table-bordered'>
                                                        <thead>
                                                            <tr>
                                                                <th>No Invoice</th>
                                                                <th>Nama Customer</th>
                                                                <th>Saldo Awal</th>
                                                                <th>Amount</th>
                                                                <th>Saldo Akhir</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {ctGiro.map((item, index) => {
                                                                if (item.DocDate == tgl.DocDate) {
                                                                    return (
                                                                        <tr key={index}>
                                                                            <td>{item.NoInvoice}</td>
                                                                            <td>{item.CustomerName}</td>
                                                                            <td>{numberFormat(item.AmountOpen)}</td>
                                                                            <td>{numberFormat(item.Amount)}</td>
                                                                            <td>{numberFormat(item.AmountBalance)}</td>
                                                                        </tr>
                                                                    )
                                                                }
                                                            })}
                                                        </tbody>
                                                        <tfoot>
                                                            <tr>
                                                                <td colSpan='2' style={{ textAlign: "right" }}>Total</td>
                                                                <td>{numberFormat(ctGiro.reduce((a, b) => a + b.AmountOpen, 0))}</td>
                                                                <td>{numberFormat(ctGiro.reduce((a, b) => a + b.Amount, 0))}</td>
                                                                <td>{numberFormat(ctGiro.reduce((a, b) => a + b.AmountBalance, 0))}</td>
                                                            </tr>
                                                        </tfoot>
                                                    </table>
                                                </div>
                                            </Fragment>
                                        )
                                    }

                                    return (<div style={{ border: "solid black 1px", padding: "20px" }} key={salesi}>
                                        <h6>{sales.SalesName}</h6>
                                        {domTF}
                                        {domTunai}
                                        {domGiro}
                                    </div>);
                                }
                            })
                        }
                        <div className='row'>
                            <div className='col-md-6 mb-2'>
                                <h4>Total Per Sales</h4>
                                <table className='table' style={{ fontSize: "24px" }}>
                                    {
                                        sql.totalSales.map((sales, index) => {
                                            if (sales.DocDate == tgl.DocDate) {
                                                TotalSales += parseFloat(sales.Total);
                                                return (
                                                    <tr key={index}>
                                                        <td width="120px">{sales.SalesName}</td>
                                                        <td width="10px">:</td>
                                                        <td>{numberFormat(sales.Total)}</td>
                                                    </tr>
                                                )
                                            }
                                        })
                                    }
                                    <tr>
                                        <td width="120px" style={{ fontWeight: "bold" }}>Total</td>
                                        <td width="10px" style={{ fontWeight: "bold" }}>:</td>
                                        <td style={{ fontWeight: "bold" }}>{numberFormat(TotalSales)}</td>
                                    </tr>
                                </table>
                            </div>
                            <div className='col-md-6 mb-2'>
                                <h4>Total Per Tipe Amount</h4>
                                <table className='table' style={{ fontSize: "24px" }}>
                                    {
                                        sql.totalType.map((tipe, index) => {
                                            if (tipe.DocDate == tgl.DocDate) {
                                                TotalType += parseFloat(tipe.Total);
                                                return (
                                                    <tr key={index}>
                                                        <td width="120px">{tipe.PaymentType}</td>
                                                        <td width="10px">:</td>
                                                        <td>{numberFormat(tipe.Total)}</td>
                                                    </tr>
                                                )
                                            }
                                        })
                                    }
                                    <tr>
                                        <td width="120px" style={{ fontWeight: "bold" }}>Total</td>
                                        <td width="10px" style={{ fontWeight: "bold" }}>:</td>
                                        <td style={{ fontWeight: "bold" }}>{numberFormat(TotalType)}</td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </Fragment>)
                }
            }
            ReactDOM.render(dom, document.getElementById('divPrint'));
            setTimeout(() => window.print(), 500);
        }

        render() {
            return (
                <Fragment>
                    <div className="card-form">
                        <div className='row'>
                            <div className='col-md-5'><h2 style={{ fontSize: "20px", fontWeight: "bold", paddingBottom: "24px" }}>Data Dikirim Ke Kacab</h2></div>
                            <div className='col-md-7'>
                                <div className='d-flex justify-content-between align-items-center gap-1'>
                                    <input type="date" className='form-control' value={this.state.D1} onChange={(e) => this.handleChangeDate('D1SelesaiKasir', e.target.value)} />
                                    <input type="date" className='form-control' value={this.state.D2} onChange={(e) => this.handleChangeDate('D2SelesaiKasir', e.target.value)} />
                                    <button className='btn btn-primary' onClick={() => this.main()}>
                                        <span className='material-icons'>search</span>
                                    </button>
                                    <button className='btn btn-primary' onClick={() => this.handlePrint()}>
                                        <span className='material-icons'>print</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <p></p>
                        <DataGrid dataSource={this.state.data} showBorders={true} allowColumnResizing={true} columnAutoWidth={true} rowAlternationEnabled={true}>
                            <Column caption="" cellRender={(rowData) => (<i className="material-icons" onClick={() => rendDetail(rowData.data.ID)}>more_horiz</i>)} />
                            {
                                this.state.Field.map((tr, ii) => {
                                    if (tr.type == "number") {
                                        return <Column dataField={tr.sort} caption={tr.cap} dataType="number" format={{ type: 'fixedPoint' }} key={ii} />
                                    } else if (tr.type == "date") {
                                        return <Column dataField={tr.sort} caption={tr.cap} dataType="date" format="dd-MM-yyyy" key={ii} />
                                    } else if (tr.type == "datetime") {
                                        return <Column dataField={tr.sort} caption={tr.cap} dataType="date" format="dd-MM-yyyy H:i:s" key={ii} />
                                    } else if (tr.type == "html") {
                                        return <Column caption={tr.cap} cellRender={(rowData) => (
                                            <div dangerouslySetInnerHTML={{ __html: rowData.data[tr.sort] }} />
                                        )} />
                                    } else {
                                        return <Column dataField={tr.sort} caption={tr.cap} key={ii} />
                                    }
                                })
                            }
                            <Paging defaultPageSize={50} />
                            <FilterRow visible={true} />
                            <HeaderFilter visible={true} />
                            <GroupPanel visible={true} />
                            <Grouping autoExpandAll={true} />
                            <ColumnFixing enabled={true} />
                            <Summary>
                                <TotalItem column="ID" summaryType="count" />
                                <GroupItem column="ID" summaryType="count" displayFormat="{0} Transaksi" />
                            </Summary>
                            <Pager allowedPageSizes={[20, 50, 100, 150]} showPageSizeSelector={true} />
                        </DataGrid>
                        <div className="table-responsive" id="divView"></div>
                    </div>
                    <nav id="paggination" style={{ paddingRight: "50px" }}></nav>
                </Fragment>
            )
        }
    }

    ReactDOM.render(<Main />, document.getElementById('tampil'))
}

function rendDetail(ini) {
    class Form extends React.Component {
        constructor(props) {
            super(props);
            this.state = {
                id: ini || "",
                data: [],
                host: window.location.hostname == "localhost" ? "http://localhost:2005/file/" : "https://penagihanapi.pxa.co.id/file/",
                Detail: {},
                dataGiro: [],
                btnKirim: true,
                D1: saiki(),
                D2: saiki(),
                divImg: []
            }
        }

        async componentDidMount() {
            ReactDOM.render(<div className='btn-kembali' onClick={() => App()}><span className="material-icons">arrow_back</span> Kembali</div>, document.getElementById('divHeaderLabel'));
            if (this.state.id !== "") {
                let sql = await api("tagihan_detail_kasir", { DocNumber: this.state.id, Token: getCookie("Token") });
                if (sql.status == "true") {
                    this.setState({ data: sql.data, btnKirim: sql.data.Status == "0" ? true : false });
                    let tunai = 0, transfer = 0, giro = 0;
                    for (let dd of sql.data) {
                        if (dd.PaymentType == "Tunai") tunai++;
                        if (dd.PaymentType == "Transfer") transfer++;
                        if (dd.PaymentType == "Giro") giro++;
                    }
                    this.setState({ CTTunai: tunai, CTTransfer: transfer, CTGiro: giro });
                }
            }
        }

        async handleDetail(detail) {
            this.setState({ Detail: detail, Notes: detail.Notes, tableGiro: [], divImg: <img src={this.state.host + detail.Berkas} style={{ width: "100%" }} /> });
            if (detail.PaymentType == "Giro") {
                let sql = await api("detail_giro", { ID: detail.ID, Token: getCookie("Token") });
                let tableGiro = <Fragment>
                    <table className='table table-bordered'>
                        <thead>
                            <tr>
                                <th>Nomor</th>
                                <th>Tanggal Jatuh Tempo</th>
                                <th>Nominal</th>
                                <th>Bank</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                sql.data.map((val, i) => {
                                    return (
                                        <tr key={i}>
                                            <td>{val.GiroNumber}</td>
                                            <td>{tanggalIndo(val.GiroTermDate)}</td>
                                            <td>{numberFormat(val.Amount)}</td>
                                            <td>{val.CoaName}</td>
                                        </tr>
                                    )
                                })
                            }
                        </tbody>
                    </table>
                </Fragment>;
                let divImg = [];
                for (let img of sql.data) {
                    divImg.push(<div className='col-md-6 mb-2'><img src={this.state.host + img.Berkas} style={{ width: "100%" }} /></div>)
                }
                let divRow = <div className='row'>{divImg}</div>;
                this.setState({ tableGiro: tableGiro, divImg: divRow });
            } else if (detail.PaymentType == "Transfer") {
                let sql = await api("detail_giro", { ID: detail.ID, Token: getCookie("Token") });
                let tableGiro = <Fragment>
                    <table className='table table-bordered'>
                        <thead>
                            <tr>
                                <th>Nominal</th>
                                <th>Bank</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                sql.data.map((val, i) => {
                                    return (
                                        <tr key={i}>
                                            <td>{numberFormat(val.Amount)}</td>
                                            <td>{val.CoaName}</td>
                                        </tr>
                                    )
                                })
                            }
                        </tbody>
                    </table>
                </Fragment>;
                this.setState({ tableGiro: tableGiro });
            }
        }

        async handleReject(ID, DocNumber) {
            let sql = await api("reject_tagihan_kasir", { ID: ID, DocNumber: DocNumber, Token: getCookie("Token") });
            if (sql.status == "true") {
                this.setState({ data: sql.data });
                pesan("Pemberitahuan", sql.message, "primary");
                document.getElementById('btnTutupDetail').click();
            } else {
                pesan("Pemberitahuan", sql.message, "danger");
            }
        }

        async handleApprove(ID, DocNumber) {
            let sql = await api("approve_tagihan_kasir", { ID: ID, DocNumber: DocNumber, Token: getCookie("Token") });
            if (sql.status == "true") {
                this.setState({ data: sql.data });
                if (sql.CT == 0) this.setState({ btnKirim: false });
                pesan("Pemberitahuan", sql.message, "primary");
                document.getElementById('btnTutupDetail').click();
            } else {
                pesan("Pemberitahuan", sql.message, "danger");
            }
        }

        async handleKirimKacab() {
            let sql = await api("kirim_tagihan_kasir", { ID: this.state.id, Token: getCookie("Token") });
            if (sql.status == "true") {
                pesan("Pemberitahuan", sql.message, "primary");
                App();
            } else {
                pesan("Pemberitahuan", sql.message, "danger");
            }
        }

        render() {
            let CTTunai = 0, SWTunai = 0, PMTunai = 0, SATunai = 0,
                CTTransfer = 0, SWTransfer = 0, PMTransfer = 0, SATransfer = 0,
                CTGiro = 0, SWGiro = 0, PMGiro = 0, SAGiro = 0;
            return (
                <Fragment>
                    <div className="card-form">
                        <h2 style={{ fontSize: "20px", fontWeight: "bold", paddingBottom: "24px" }}>Data Baru</h2>
                        <div className='row'>
                            <div className='col-md-9'></div>
                            <div className='col-md-3'>
                                <div className='input-icons'>
                                    <span className='material-icons icon-search'>search</span>
                                    <input className="form-control search-form" type="search" name="search" placeholder="Search" value={this.state.search} onChange={(e) => this.handleChange(e, "search")} required />
                                </div>
                            </div>
                        </div>
                        <p></p>
                        <div className="table-responsive" style={{ display: this.state.CTTunai == 0 ? "none" : "block" }}>
                            <h6>Amount Tunai</h6>
                            <table className='table table-bordered'>
                                <thead>
                                    <tr>
                                        <th width="80px"></th>
                                        <th width="180px">No Pusat</th>
                                        <th width="180px">No Invoice</th>
                                        <th width="150px">Pelanggan</th>
                                        <th width="150px">Jenis Amount</th>
                                        <th width="120px">Saldo Awal</th>
                                        <th width="120px">Amount</th>
                                        <th width="120px">Saldo Akhir</th>
                                        <th width="150px">Tanggal Pelunasan</th>
                                        <th width="100px">PPN</th>
                                        <th>Status</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        this.state.data.map((item, index) => {
                                            if (item.PaymentType == "Tunai") {
                                                let State = <span className="badge bg-danger">Reject</span>;
                                                if (item.KasirState == 0) {
                                                    State = <span className='badge bg-warning'>Menunggu</span>;
                                                } else if (item.KasirState == 1) {
                                                    State = <span className='badge bg-primary'>Approve</span>;
                                                }
                                                CTTunai++;
                                                SWTunai += item.AmountOpen;
                                                PMTunai += item.Amount;
                                                SATunai += item.AmountBalance;
                                                return (
                                                    <tr>
                                                        <td>
                                                            <button className='btn' onClick={() => this.handleDetail(item)} data-bs-toggle="modal" data-bs-target="#exampleModal">
                                                                <span className='material-icons'>visibility</span>
                                                            </button>
                                                        </td>
                                                        <td>{item.PusatID}</td>
                                                        <td>{item.NoInvoice}</td>
                                                        <td>{item.CustomerName}</td>
                                                        <td>{item.PaymentType}</td>
                                                        <td>{numberFormat(item.AmountOpen)}</td>
                                                        <td>{numberFormat(item.Amount)}</td>
                                                        <td>{numberFormat(item.AmountBalance)}</td>
                                                        <td>{tanggalIndo(item.TanggalPembayaran)}</td>
                                                        <td>{item.TaxType}</td>
                                                        <td>{State}</td>
                                                    </tr>
                                                )
                                            }
                                        })
                                    }
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <td></td>
                                        <td>{CTTunai}</td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td>{numberFormat(SWTunai)}</td>
                                        <td>{numberFormat(PMTunai)}</td>
                                        <td>{numberFormat(SATunai)}</td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                        <div className='table-responsive' style={{ display: this.state.CTTransfer == 0 ? "none" : "block" }}>
                            <h6>Amount Transfer</h6>
                            <table className='table table-bordered'>
                                <thead>
                                    <tr>
                                        <th width="80px"></th>
                                        <th width="180px">No Invoice</th>
                                        <th width="150px">Pelanggan</th>
                                        <th width="150px">Jenis Amount</th>
                                        <th width="120px">Saldo Awal</th>
                                        <th width="120px">Amount</th>
                                        <th width="120px">Saldo Akhir</th>
                                        <th width="150px">Tanggal Pelunasan</th>
                                        <th width="150px">PPN</th>
                                        <th>Status</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        this.state.data.map((item, index) => {
                                            if (item.PaymentType == "Transfer") {
                                                let State = <span className="badge bg-danger">Reject</span>;
                                                if (item.KasirState == 0) {
                                                    State = <span className='badge bg-warning'>Menunggu</span>;
                                                } else if (item.KasirState == 1) {
                                                    State = <span className='badge bg-primary'>Approve</span>;
                                                }
                                                CTTransfer++;
                                                SWTransfer += item.AmountOpen;
                                                PMTransfer += item.Amount;
                                                SATransfer += item.AmountBalance;
                                                return (
                                                    <tr>
                                                        <td>
                                                            <button className='btn' onClick={() => this.handleDetail(item)} data-bs-toggle="modal" data-bs-target="#exampleModal">
                                                                <span className='material-icons'>visibility</span>
                                                            </button>
                                                        </td>
                                                        <td>{item.NoInvoice}</td>
                                                        <td>{item.CustomerName}</td>
                                                        <td>{item.PaymentType}</td>
                                                        <td>{numberFormat(item.AmountOpen)}</td>
                                                        <td>{numberFormat(item.Amount)}</td>
                                                        <td>{numberFormat(item.AmountBalance)}</td>
                                                        <td>{tanggalIndo(item.TanggalPembayaran)}</td>
                                                        <td>{item.TaxType}</td>
                                                        <td>{State}</td>
                                                    </tr>
                                                )
                                            }
                                        })
                                    }
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <td></td>
                                        <td>{CTTransfer}</td>
                                        <td></td>
                                        <td></td>
                                        <td>{numberFormat(SWTransfer)}</td>
                                        <td>{numberFormat(PMTransfer)}</td>
                                        <td>{numberFormat(SATransfer)}</td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                        <div className='table-responsive' style={{ display: this.state.CTGiro == 0 ? "none" : "block" }}>
                            <h6>Amount Giro</h6>
                            <table className='table table-bordered'>
                                <thead>
                                    <tr>
                                        <th width="80px"></th>
                                        <th width="180px">No Invoice</th>
                                        <th width="150px">Pelanggan</th>
                                        <th width="150px">Jenis Amount</th>
                                        <th width="120px">Saldo Awal</th>
                                        <th width="120px">Amount</th>
                                        <th width="120px">Saldo Akhir</th>
                                        <th width="150px">Tanggal Giro</th>
                                        <th width="150px">Nomor Giro</th>
                                        <th width="150px">PPN</th>
                                        <th>Status</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        this.state.data.map((item, index) => {
                                            if (item.PaymentType == "Giro") {
                                                let State = <span className="badge bg-danger">Reject</span>;
                                                if (item.KasirState == 0) {
                                                    State = <span className='badge bg-warning'>Menunggu</span>;
                                                } else if (item.KasirState == 1) {
                                                    State = <span className='badge bg-primary'>Approve</span>;
                                                }
                                                CTGiro++;
                                                SWGiro += item.AmountOpen;
                                                PMGiro += item.Amount;
                                                SAGiro += item.AmountBalance;
                                                return (
                                                    <tr>
                                                        <td>
                                                            <button className='btn' onClick={() => this.handleDetail(item)} data-bs-toggle="modal" data-bs-target="#exampleModal">
                                                                <span className='material-icons'>visibility</span>
                                                            </button>
                                                        </td>
                                                        <td>{item.NoInvoice}</td>
                                                        <td>{item.CustomerName}</td>
                                                        <td>{item.PaymentType}</td>
                                                        <td>{numberFormat(item.AmountOpen)}</td>
                                                        <td>{numberFormat(item.Amount)}</td>
                                                        <td>{numberFormat(item.AmountBalance)}</td>
                                                        <td>{tanggalIndo(item.TanggalJatuhTempoGiro)}</td>
                                                        <td>{item.GiroNumber}</td>
                                                        <td>{item.TaxType}</td>
                                                        <td>{State}</td>
                                                    </tr>
                                                )
                                            }
                                        })
                                    }
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <td></td>
                                        <td>{CTGiro}</td>
                                        <td></td>
                                        <td></td>
                                        <td>{numberFormat(SWGiro)}</td>
                                        <td>{numberFormat(PMGiro)}</td>
                                        <td>{numberFormat(SAGiro)}</td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>

                    <div className="modal fade" id="exampleModal" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                        <div className="modal-dialog modal-lg">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title" id="exampleModalLabel">Detail Invoice</h5>
                                    <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                                </div>
                                <div className="modal-body">
                                    <div className='row'>
                                        <div className='col-md-6'>
                                            <table className='table table-striped'>
                                                <tbody>
                                                    <tr>
                                                        <td>Nama Pelanggan</td>
                                                        <td>:</td>
                                                        <td>{this.state.Detail.CustomerName}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>No Invoice</td>
                                                        <td>:</td>
                                                        <td>{this.state.Detail.NoInvoice}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Saldo Awal</td>
                                                        <td>:</td>
                                                        <td>{numberFormat(this.state.Detail.AmountOpen)}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Amount</td>
                                                        <td>:</td>
                                                        <td>{numberFormat(this.state.Detail.Amount)}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Saldo Akhir</td>
                                                        <td>:</td>
                                                        <td>{numberFormat(this.state.Detail.AmountBalance)}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Tanggal Pelunasan</td>
                                                        <td>:</td>
                                                        <td>{tanggalIndo(this.state.Detail.TanggalPembayaran)}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Jenis Pembayaran</td>
                                                        <td>:</td>
                                                        <td>{this.state.Detail.PaymentType}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>PPN</td>
                                                        <td>:</td>
                                                        <td>{this.state.Detail.TaxType}</td>
                                                    </tr>
                                                    {this.state.dataGiro}
                                                </tbody>
                                            </table>
                                            <div className='table-responsive'>{this.state.tableGiro}</div>
                                        </div>
                                        <div className='col-md-6'>
                                            {this.state.divImg}
                                        </div>
                                    </div>

                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" id="btnTutupDetail" data-bs-dismiss="modal">Tutup</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </Fragment>
            )
        }
    }

    ReactDOM.render(<Form />, document.getElementById('tampil'));
}
export default App;